import React from 'react'

import CourseDetails from 'screens/AuthenticatedArea/CourseDetails'

export default function MVUEssentialsCourseDetails() {
  return <CourseDetails portal="essentials" />
}
